import React from 'react';
import { Link } from 'react-router-dom';
import { dailyFreePlayLimitMessage } from '../utils/freePlayLimit';

const MembershipPrompts = ({ id, textosShow, kind = 'room', includeDailyLimit = true }) => (
  <>
    <div className='mt_block step_5' id={'subscribe_now_' + kind + '_' + id}>
      <div className='step'></div>
      {textosShow.sololasusuariospremiumpuedenparticiparentorneosfreeroll || 'Only premium users can enter freeroll tournaments.'}
      <div className='notif_buttons'>
        <button className='button green_button'><Link to='/subscription'>{textosShow.suscribirarahora || 'Suscribir'}</Link></button>
      </div>
    </div>
    {includeDailyLimit && (
      <div className='mt_block step_5' id={'subscribe_now_more_' + kind + '_' + id}>
        <div className='step'></div>
        {dailyFreePlayLimitMessage(textosShow)}
        <div className='notif_buttons'>
          <button className='button green_button'><Link to='/subscription'>{textosShow.suscribirarahora || 'Suscribir'}</Link></button>
        </div>
      </div>
    )}
  </>
);

export default MembershipPrompts;
